export function AccordionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 16 16"
    >
      <g fill="black">
        <path d="M0 4v8h16V4H0zm15 7H1V7h14v4zM0 0h16v3H0V0zM0 13h16v3H0v-3z" />
      </g>
    </svg>
  );
}
